import toast from "react-hot-toast";
import { axiosInstance } from "../lib/axios";
import Cookies from 'js-cookie';


export const getAboutUs = async () => {
    try {
        const res = await axiosInstance.get(`/aboutus`)
        // toast.success("Successfully fetched!");
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

export const postStory = async (form) => {
    try {
        const {
            title, subTitle, images, description, buttonText
        } = form;

        const formData = new FormData();

        formData.append("title", title);
        formData.append("subTitle", subTitle);
        formData.append("buttonText", buttonText);
        formData.append("description", description);


        if (images.length > 0) {
            for (let i = 0; i < (images || []).length; i++) {

                if (typeof images[i] === "string")
                    formData.append("images", images[i]);
                else {
                    formData.append("pictures", images[i]);
                }
            }
        }

        const accessToken = Cookies.get("accessToken");

        const res = await axiosInstance.post(
            `/aboutus/story`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        toast.success("Successfully Registered!");
        return res.data?.data;

    } catch (err) {
        console.error(err);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

export const postPromise = async (form) => {
    try {
        const {
            title, subTitle, images, description, buttonText
        } = form;

        const formData = new FormData();

        formData.append("title", title);
        formData.append("subTitle", subTitle);
        formData.append("buttonText", buttonText);
        formData.append("description", description);


        if (images.length > 0) {
            for (let i = 0; i < (images || []).length; i++) {

                if (typeof images[i] === "string")
                    formData.append("images", images[i]);
                else {
                    formData.append("pictures", images[i]);
                }
            }
        }

        const accessToken = Cookies.get("accessToken");

        const res = await axiosInstance.post(
            `/aboutus/promise`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        toast.success("Successfully Registered!");
        return res.data?.data;

    } catch (err) {
        console.error(err);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

export const postMission = async (form) => {
    try {
        const {
            title, subTitle, images, description, buttonText
        } = form;

        const formData = new FormData();

        formData.append("title", title);
        formData.append("subTitle", subTitle);
        formData.append("buttonText", buttonText);
        formData.append("description", description);

        if (typeof images === "string")
            formData.append("images", images);
        else {
            formData.append("pictures", images);
        }

        const accessToken = Cookies.get("accessToken");

        const res = await axiosInstance.post(
            `/aboutus/mission`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        toast.success("Successfully Registered!");
        return res.data?.data;

    } catch (err) {
        console.error(err);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

export const postFounderFunction = async (form) => {
    try {
        const {
            title, subTitle, image, description, buttonText
        } = form;

        const formData = new FormData();

        formData.append("title", title);
        formData.append("subTitle", subTitle);
        formData.append("buttonText", buttonText);
        formData.append("description", description);

        if (typeof image === "string")
            formData.append("image", image);
        else {
            formData.append("pictures", image);
        }

        const accessToken = Cookies.get("accessToken");

        const res = await axiosInstance.post(
            `/aboutus/founder`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        toast.success("Successfully Registered!");
        return res.data?.data;

    } catch (err) {
        console.error(err);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};